import type z from 'zod';
import { ValidationError } from '@pdcfrontendui/staffplan';

export function validate<T>(schema: z.ZodType<T>, x: { result: unknown }): T {
  const result = schema.safeParse(x.result);
  if (!result.success) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const first = result.error.issues[0]!;
    const prop = 'path' in first ? first.path.join('.') : '';
    const expectedType = 'expected' in first ? first.expected : 'unknown';
    throw new ValidationError(
      typeof x.result === 'object' && x.result !== null ? x.result : x,
      prop,
      expectedType
    );
  }
  return result.data;
}
